/**
 * Optional env-only header/login accent override.
 * Returns a CSS variable reference from design-tokens.css — never a hex literal.
 *   next     → var(--ajw-red)
 *   cypress  → var(--env-cypress-green)
 *   otherwise → undefined (UI uses --ajw-purple from design-tokens)
 */
export const getEnvBrandColor = (): string | undefined => {
  const env = (process.env.REACT_APP_ENVIRONMENT || "")
    .replace(/"/g, "")
    .trim();
  if (env === "next") return "var(--ajw-red)";
  if (env === "cypress") return "var(--env-cypress-green)";
  return undefined;
};
